import { Skill } from "@/core/skills/types";
import { createInitialPetitionSkill } from "@/core/skills/implementations";
import { Area } from "@/contexts/MessagesContext";

export const createCivilInitialPetitionSkill: Skill<typeof createInitialPetitionSkill.inputSchema> = {
  ...createInitialPetitionSkill,
  id: "create_civil_initial_petition",
  name: "Escrever petição inicial cível",
  tags: [...createInitialPetitionSkill.tags, "mostUsed"],
  initialValue: {
    area: Area.CIVIL,
  },
};
